'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgPersonCircleFill = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2Zm0 18c-2.6 0-4.9-1.25-6.36-3.17L6.3 15h11.4l.66 1.83C16.9 18.75 14.6 20 12 20Zm-.01-13.96c2.06 0 3.74 1.68 3.74 3.74 0 2.06-1.68 3.74-3.74 3.74-2.06 0-3.74-1.68-3.74-3.74 0-2.06 1.68-3.74 3.74-3.74Z" })
);

module.exports = SvgPersonCircleFill;
//# sourceMappingURL=PersonCircleFill.cjs.js.map
